import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';

@Injectable()
export class UploadsService extends ParentService {
  private progress$: any;
  private progress: any;
  private progressObserver: any;

  constructor(private _http: Http) {
    super();
  }

  /**
   * @name makeFileRequest
   * @description
   * @param {string} url
   * @param {string[]} params
   * @param {File[]} files
   * @returns Observable<any>
   *
   */
  public makeFileRequest(
    url: string,
    params: { nameParam: string, data: any }[],
    files: File[],
    propertyName = 'uploads[]'
  ): Observable <any> {

    return Observable.create(observer => {
      this.progressObserver = observer;

      const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      for (let i = 0; i < files.length; i++) {
        formData.append(propertyName, files[i], files[i].name);
      }

      if (params.length) {
        params.forEach(row => {
          formData.append(row.nameParam, JSON.stringify(row.data));
        });
      }

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(JSON.parse(xhr.response));
            observer.complete();
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round((event.loaded / event.total) * 100);
        this.progressObserver.next(this.progress);
      };
      xhr.open('POST', url, true);
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      xhr.setRequestHeader('Authorization', `Session ${token}`);
      xhr.send(formData);
    });
  }

  /**
   * @name getRowsImports
   * @description
   * @param {any} fileId
   */
  public getRowsImports(fileId: any) {
    const url = constant.URL_IMPORT_PAYOR + fileId;
    return this._http
      .get(url, this.getHeader())
      .map(res => res.json());
  }

  public makeSimplyFileRequest<T>(
    url: string,
    file: File
  ): Observable<T> {

    return Observable.create(observer => {
      this.progressObserver = observer;

      const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      formData.append('file', file, file.name);

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(JSON.parse(xhr.response));
            observer.complete();
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          this.progress = Math.round((event.loaded / event.total) * 100);
          this.progressObserver.next(this.progress);
        }
      };

      xhr.open('POST', url, true);
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      xhr.setRequestHeader('Authorization', `Session ${token}`);
      xhr.send(formData);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/uploads.service.ts